import { useCallback } from "react";

import { dispatchAddEvent } from "@/app/hooks/useAnalyticsManager";
import { useLocationDetails } from "@/app/hooks/useLocationDetails";
import sendBeginCheckoutEvent, { BeginCheckoutRequest } from "@/fetch/sendBeginCheckoutEvent";
import { useGetShoppingCartQuery } from "@/store/shoppingCartApi";
import { useGetUserQuery } from "@/store/userApi";

export const useDispatchBeginCheckout = () => {
  const { data: user } = useGetUserQuery();
  const { zipCode } = useLocationDetails();
  const { isLoading: shoppingCartIsLoading, data: shoppingCart } = useGetShoppingCartQuery(undefined, {
    skip: !zipCode,
  });

  const dispatchToClientAndServerContainer = useCallback(
    (cart?: ShoppingCartState, userId?: number, IsGuestUser?: boolean) => {
      const cartToUse = cart ?? shoppingCart;
      const event_id = `beginCheckout-${user?.UserId ?? userId}-${Date.now()}`;
      const items = cartToUse?.vendorOrders?.flatMap((vendorOrder) =>
        vendorOrder?.products?.map((p) => ({
          item_id: String(p?.mpId),
          item_name: p?.productTitle,
          price: p?.subtotal,
          quantity: p?.quantity,
        })),
      );
      const payload = {
        event_id,
        user_id: user?.UserId,
        currency: "USD",
        value: cartToUse?.grandTotal,
        items,
      } as BeginCheckoutRequest;
      const shouldDispatchEvent =
        (user && !user?.IsGuestUser && shoppingCart && !shoppingCartIsLoading) || (cart && !IsGuestUser);
      if (shouldDispatchEvent) {
        sendBeginCheckoutEvent(payload);
        dispatchAddEvent({
          event_id: event_id,
          user_id: user?.UserId,
          eventName: "begin_checkout",
          currency: "USD",
          checkoutCart: cartToUse ?? null,
        });
      }
    },
    [shoppingCart, shoppingCartIsLoading, user],
  );

  return dispatchToClientAndServerContainer;
};
